export default __webpack_public_path__ + "images/pending_d030c1.svg";